<template>
  <section class="logistic-traceability">
    <traceability-back-button @click="goBack" />

    <h2 class="logistic-traceability-title">
      Rastreabilidade logística
    </h2>

    <date-range-filter :key="$route.path" />

    <tab-buttons
      class="print-labels-view-header-tab-buttons"
      :tabs="tabs"
    />

    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
  </section>
</template>

<script>
import TabButtons from '@/components/common/TabButtons'

import DateRangeFilter from './DateRangeFilter'
import TraceabilityBackButton from './TraceabilityBackButton'

export default {
  name: 'LogisticTraceability',
  components: {
    TabButtons,
    DateRangeFilter,
    TraceabilityBackButton
  },
  computed: {
    tabs() {
      return [
        {
          label: 'Lotes',
          to: '/traceability/logistic/batches'
        },
        {
          label: 'Amostras',
          to: '/traceability/logistic/samples'
        }
      ]
    }
  },
  methods: {
    goBack() {
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style lang="scss" scoped>
  .logistic-traceability {
    font-family: 'Exo 2';

    &-title {
      font-weight: 700;
      font-size: 2.125rem;
      color: #818181;
      margin-bottom: 2rem;
    }
  }
</style>
